import React from "react";


import undraw_vector from "../../assets/celebration_re_kc9k 1.png";
import BZLogo from "../../components/BZLogo";
import { TwButton, TwMainLayout } from "../../components/tailwind";
import { OnBordingBaseLayout } from "../signup/onbording";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function BusinessProfileUpComplete({ navigation }) {

  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  return (
    <TwMainLayout fullScreen={true}>
      <OnBordingBaseLayout
        title={<BZLogo className={"!max-h-12 h-auto sm:!w-auto"} />}
        logoutCallBack={() => { }}
      >
        <div className="flex flex-col justify-center items-center p-5">
          <img
            className={"mt-5 md:mt-0 p-5 w-full md:w-9/12 [lg:w-6/12] lg:w-1/3 flex-1"}
            src={undraw_vector}
            alt={"vector"}
          />
          <h4
            className={
              "text-primary text-2xl sm:text-3xl font-bold my-4 sm:my-2 md:my-2 text-center"
            }
          >
            Congratulations,
            <br />
            Profile Completed!
          </h4>
          <p
            className={
              "text-primary text-center text-xl sm:text-lg my-4 sm:my-2 md:my-2"
            }
          >
            Let's continue to your Dashboard!
          </p>
          <TwButton
            className="w-full sm:w-auto sm:min-w-72 xs:text-base sm:text-xl"
            onClick={() => navigate("/home/dashboard")}
          >
            {t("inputFieldsTitle.continue")}
          </TwButton>
        </div>
      </OnBordingBaseLayout>
    </TwMainLayout>
  );
}
